var fbPixelTracker = null;
var fbPixelCanTrack = null;

(function () {
    var s = (typeof (Vendd) != "undefined" && Vendd.Scripts) || (typeof (Scripts) != "undefined" && Scripts);
    if (!s) return;
    s.load(function () {
        'use strict';
        var TrackingScriptName = 'FacebookPixel';
 
        var TrackingModel = LhApp.Function.Tracking.getTrackingModel();
        fbPixelTracker = LhApp.Function.Tracking.getTracker("facebook", TrackingModel);

        if (!fbPixelTracker || !fbPixelTracker.Properties.FacebookPixelId)
            return;

        window.dataLayer = window.dataLayer || [];

        fbPixelCanTrack = LhApp.Function.Tracking.canTrack();

        var _cartAddResponses = []; // holds a response for every cart add action. 
        var _isUserSelectedProduct;

        Init();

        function Init() {
            if (!fbPixelCanTrack) return;

            //include facebook tracking script
            (function (f, b, e, v, n, t, s) {
                if (f.fbq) return;
                n = f.fbq = function () {
                    n.callMethod ?
                        n.callMethod.apply(n, arguments) : n.queue.push(arguments);
                };
                if (!f._fbq) f._fbq = n;
                n.push = n;
                n.loaded = !0;
                n.version = '2.0';
                n.queue = [];
                t = b.createElement(e);
                t.async = !0;
                t.src = v;
                s = b.getElementsByTagName(e)[0];
                s.parentNode.insertBefore(t, s)
            })(window, document, 'script', '//connect.facebook.net/en_US/fbevents.js');
            fbq('init', fbPixelTracker.Properties.FacebookPixelId);

            //TRACK page view
            var uniquePageId = 'PageView_' + generateUniqueId();

            fbq('track', 'PageView', {}, { eventID: uniquePageId });

            dataLayer.push({ PageView_eventID: null });
            dataLayer.push({ PageView_eventID: uniquePageId });

            //TRACK product list 
            if (TrackingModel.IsProductListPage && TrackingModel.ProductListsData) {
                var ids = [];
                for (var list in TrackingModel.ProductListsData) {
                    var listItems = TrackingModel.ProductListsData[list];
                    for (var i = 0; i < listItems.length; i++) {
                        var product = listItems[i];
                        var productId = LhApp.Function.Tracking.getFeedItemId(product, null, fbPixelTracker);

                        if (ids.indexOf(productId) < 0)
                            ids.push(productId);
                    };
                }

                var uniquePLId = 'ViewCategory_' + generateUniqueId();

                fbq('track', 'ViewCategory', {
                    content_type: 'product',
                    content_category: TrackingModel.CategoryName,
                    content_ids: ids
                }, { eventID: uniquePLId });

                dataLayer.push({ ViewCategory_eventID: null });
                dataLayer.push({ ViewCategory_eventID: uniquePLId });
            }

            //TRACK product details
            if (TrackingModel.IsProductDetailsPage && TrackingModel.ProductData && TrackingModel.ProductData.length > 0) {
                var product = TrackingModel.ProductData[0];
                var productId = LhApp.Function.Tracking.getFeedItemId(product, null, fbPixelTracker);
                var uniquePDId = 'ViewContent_' + generateUniqueId();

                fbq('track', 'ViewContent', {
                    content_type: 'product',
                    content_ids: [productId],
                    content_name: product.Name,
                    content_category: product.Category,
                    value: product.PriceN,
                    currency: LhApp.Context.Currency.Code
                }, { eventID: uniquePDId });

                dataLayer.push({ ViewContent_eventID: null });
                dataLayer.push({ ViewContent_eventID: uniquePDId });
            }

            //TRACK order completion
            if (TrackingModel.IsThankYouPage && TrackingModel.CartProductsData && TrackingModel.Order) {
                if (TrackingModel.Order.IsAlreadyTracked)
                    return;

                var orderproductIds = [];
                var orderNames = [];
                var categories = [];
                var items = TrackingModel.CartProductsData;
                var orderproductIdsOBJarr = [];
               
                for (var i = 0; i < items.length; i++) {
                    var product = items[i];
                    var productId = LhApp.Function.Tracking.getFeedItemId(product, null, fbPixelTracker);

                    orderproductIds.push(productId);
                    categories.push(product.Category);
                    orderNames.push(product.Name);
                    orderproductIdsOBJarr.push({ id: productId, quantity: product.Quantity });
                }

                fbq('track', 'Purchase', {
                    content_type: 'product',
                    content_ids: orderproductIds,
                    content_name: orderNames,
                    value: TrackingModel.Order.TotalPriceN,
                    currency: LhApp.Context.Currency.Code,
                    content_category: categories,
                    contents: orderproductIdsOBJarr
                }, { eventID: 'Purchase_' + TrackingModel.Order.Code });

                dataLayer.push({ Purchase_eventID: null });
                dataLayer.push({ Purchase_eventID: 'Purchase_' + TrackingModel.Order.Code });
            }

            // TRACK Search & SearchTerm - for SearchProducts
            if ($('.search-region[data-searchterm]').length > 0) {
                var uniqueSearchId = 'Search_' + generateUniqueId();
                var uniqueSearchTermTId = 'SearchTerm_' + generateUniqueId();

                fbq('track', 'Search', {}, { eventID: uniqueSearchId });

                dataLayer.push({ Search_eventID: null });
                dataLayer.push({ Search_eventID: uniqueSearchId });

                fbq('trackCustom', 'SearchTerm', {
                    search_string: $('.search-region[data-searchterm]').data('searchterm')
                }, { eventID: uniqueSearchTermTId });

                dataLayer.push({ SearchTerm_eventID: null });
                dataLayer.push({ SearchTerm_eventID: uniqueSearchTermTId });
            }
        }

        function generateUniqueId() {
            var uniqueId = "";

            for (var i = 0; i < 6; i++) {
                uniqueId += Math.random().toString(36).slice(2, 12);
            }

            return (new Date().getTime()).toString(36) + uniqueId;
        }

        // IMPORTANT execute this scripts in all other pages except checout
        if (typeof (Vendd) != "undefined" && Vendd.Scripts) {

            //HELPER this script keep track of products added to cart
            Vendd.MessageBus.subscribe(Vendd.Cart.Messages.Add, TrackingScriptName, function (envelope) {
                if (!fbPixelCanTrack) return;

                var res = envelope.message.data;
                _cartAddResponses.push({
                    ProductId: res.id,
                    SkuId: res.skuId,
                    Quantity: parseFloat(res.qty)
                });
                
            });
            //TRACK add to cart (recorded by the ABOVE script)
            Vendd.MessageBus.subscribe(Vendd.Cart.Messages.Changed, TrackingScriptName, function (envelope) {
                if (!fbPixelCanTrack) return;

                var cartModel = envelope.message.data.Cart;

                var pAddResponse = _cartAddResponses.shift();
                (function AddToCartTrack(p) {
                    if (!p)
                        return;

                    var pCartItemModel = cartModel.Items.filter(function (i) {
                        return i.ProductId == p.ProductId && i.VariantId == p.SkuId;
                    })[0];

                    if (pCartItemModel) {
                        var product = pCartItemModel;
                        var productId = LhApp.Function.Tracking.getFeedItemId(product, null, fbPixelTracker);
                        var productContent = [{ id: productId, quantity: pAddResponse.Quantity }];
                        var uniqueATCId = 'AddToCart_' + generateUniqueId();

                        fbq('track', 'AddToCart', {
                            content_type: 'product',
                            contents: productContent, //[productId],
                            content_name: pCartItemModel.Title,
                            content_category: pCartItemModel.Category,
                            value: pCartItemModel.Prices.PriceN,
                            currency: LhApp.Context.Currency.Code
                        }, { eventID: uniqueATCId });

                        dataLayer.push({ AddToCart_eventID: null });
                        dataLayer.push({ AddToCart_eventID: uniqueATCId });
                    }

                    AddToCartTrack(_cartAddResponses.shift());

                })(pAddResponse);
                
            });

            Vendd.MessageBus.subscribe(Vendd.Product.Messages.SetSelected, TrackingScriptName, function (envelope) {
                //determine if this has been auto raised during product details load in order to avoid tracking twice the product view
                _isUserSelectedProduct = envelope.message.data.visitorInitiated;
            });
            //TRACK product view (changed)
            Vendd.MessageBus.subscribe(Vendd.Product.Messages.Changed, TrackingScriptName, function (envelope) {
                if (!fbPixelCanTrack) return;

                if (!_isUserSelectedProduct)
                    return;

                var model = envelope.message.data.model;
                var product = model;
                var productId = LhApp.Function.Tracking.getFeedItemId(product, 'ProductChanged', fbPixelTracker);
                var uniqueVCId = 'ViewContent_' + generateUniqueId();

                fbq('track', 'ViewContent', {
                    content_type: 'product',
                    content_ids: [productId],
                    content_name: model.Name,
                    content_category: model.Category,
                    value: model.Prices.UnitPriceN,
                    currency: LhApp.Context.Currency.Code
                }, { eventID: uniqueVCId });

                dataLayer.push({ ViewContent_eventID: null });
                dataLayer.push({ ViewContent_eventID: uniqueVCId });
            });
        }
    });
})();